import React, { useState } from 'react';
import './About.css';
import CarouselAbout from '../components/CarouselAbout';
import OUR_MISSION from '../images/OUR_MISSION.webp';
import our_vision from '../images/our_vision.webp';
import Gratitude from '../images/Gratitude.webp';
// import story from '../images/story.webp';
// import legal from '../images/legal.webp';
import certificate12A from '../images/12A_Certificate.pdf';
import certificate80G from '../images/80G_Certificate.pdf';
import certificateISO from '../images/ISO_Certificate.pdf';
import certificateCSR from '../images/CSR_Certificate.pdf';
import CharityCertificate from '../images/CharityCertificate.jpg';
import DarpanCertificate from '../images/DarpanCertificate.pdf';

const About = () => {
  const [loadedImages, setLoadedImages] = useState(new Set());

  const handleImageLoad = (imageName) => {
    setLoadedImages(prev => new Set(prev).add(imageName));
  };

  const isImageLoaded = (imageName) => {
    return loadedImages.has(imageName);
  };

  return (
    <>
      <CarouselAbout />
      <div className="about-us-container">
        {/* Mission Section */}
        <section className="mission-section">
          <div className="section-container">
            <div className="mission-content">
              <h2>Our Mission</h2>
              <div className='justified-text'>
                <p>
                  1.	To go beyond imparting knowledge by transforming lives through compassionate actions by not only educating minds but also addressing the deeper needs of individuals and communities through empathy, care, and purposeful service.
                </p>
                <p>
                  2.	To serve through action by providing education to the underprivileged, access to healthcare, skill development for youth, empowerment for women, and dignified social support for those in need, as the living expression of our mission.
                </p>
                <p>
                  3.	To expand presence on digital platforms and community outreach, IRC serves as a voice of clarity in a world clouded by confusion and misinformation thereby removing doubts, reviving faith, and restoring trust in the beauty of Islam.
                </p>
                <p>
                  4.	To deliver authentic, well-referenced Islamic knowledge in a clear and simplified format thereby removing barriers of language, complexity, and misinformation, so that every seeker can access and implement true Islamic guidance.
                </p>
              </div>
            </div>
            <div className="mission-image">
              <div className="image-wrapper">
                {!isImageLoaded('OUR_MISSION') && (
                  <div className="image-placeholder">
                    <div className="loading-spinner"></div>
                    <span>Loading...</span>
                  </div>
                )}
                <img
                  src={OUR_MISSION}
                  alt="Our Mission"
                  loading="lazy"
                  className={isImageLoaded('OUR_MISSION') ? 'loaded' : 'loading'}
                  onLoad={() => handleImageLoad('OUR_MISSION')}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    handleImageLoad('OUR_MISSION');
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Vision Section */}
        <section className="history-section">
          <div className="section-container">
            <div className="history-image">
              <div className="image-wrapper">
                {!isImageLoaded('our_vision') && (
                  <div className="image-placeholder">
                    <div className="loading-spinner"></div>
                    <span>Loading...</span>
                  </div>
                )}
                <img
                  src={our_vision}
                  alt="Our Vision"
                  loading="lazy"
                  className={isImageLoaded('our_vision') ? 'loaded' : 'loading'}
                  onLoad={() => handleImageLoad('our_vision')}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    handleImageLoad('our_vision');
                  }}
                />
              </div>
            </div>
            <div className="history-content">
              <h2>Our Vision</h2>
              <div className='justified-text'>
                <p>
                  1.	To build a compassionate society where education and empathy go hand in hand uplifting hearts, minds, and lives.
                </p>
                <p>
                  2.	To become a trusted global platform that dispels misinformation and revives the beauty of Islam through digital innovation and meaningful community engagement.
                </p>
                <p>
                  3.	To lead in developing a skilled, self-reliant workforce through our technical institutions—empowering individuals with practical abilities to shape their own futures.
                </p>
                <p>
                  4.	To create a future where authentic Islamic knowledge is accessible to every seeker, empowering individuals to live with clarity, faith, and purpose.
                </p>
                <p>
                  <strong>
                    None of this would be possible without the solid trust and generous support of our
                    donors. Their contributions empower IRC to serve with fairness, integrity, and
                    impact—fulfilling our mission
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Gratitude Section */}
        <section className="history-section">
          <div className="section-container">
            <div className="history-content">
              <h2>Gratitude &amp; Trust: The Backbone of Our Welfare Work</h2>
              <div className='justified-text'>
                <p>
                  The reach and impact of IRC's social welfare efforts are made possible by the generous
                  donations of individuals who believe in our mission and trust our integrity.
                </p>
                <p>
                  IRC is committed to ensuring every donated rupee reaches the rightful beneficiaries, whether
                  in the form of quality healthcare, skill training, educational assistance, or essential relief.
                  We are driven by a sense of amanah (trust), knowing that every contribution carries with it
                  the hope of positive change.
                </p>
                <p>
                  We remain deeply grateful to our supporters, and continue to uphold their trust by maintaining
                  transparency, impact-driven implementation, and a strong moral commitment to the communities
                  we serve.
                </p>
              </div>
            </div>
            <div className="history-image">
              <div className="image-wrapper">
                {!isImageLoaded('Gratitude') && (
                  <div className="image-placeholder">
                    <div className="loading-spinner"></div>
                    <span>Loading...</span>
                  </div>
                )}
                <img
                  src={Gratitude}
                  alt="Gratitude and Trust"
                  loading="lazy"
                  className={isImageLoaded('Gratitude') ? 'loaded' : 'loading'}
                  onLoad={() => handleImageLoad('Gratitude')}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    handleImageLoad('Gratitude');
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="mission-section">
          <div className="section-container">
            <div className="mission-content">
              <h2>Our Story</h2>
              <div className='justified-text'>
                <p>
                  What began as one man's search for truth has grown into a movement that touches
                  millions.
                </p>
                <p>
                  More than 25 years ago, Adv. Faiz Syed set out on a path of deep study, navigating
                  the vast oceans of complex Islamic texts, from the Qur'an to classical Hadith
                  compilations and scholarly works. He realized that for the average seeker, access
                  to authentic Islamic knowledge was blocked, not by lack of sincerity, but by
                  language barriers, outdated beliefs, and a maze of misinformation. So, he
                  dedicated his life to simplifying, referencing, and sharing that knowledge
                  honestly, clearly, and fearlessly.
                </p>
                <p>
                  People began to listen. First in person, then on YouTube, in conferences, on
                  television panels. They came not just for answers, but for clarity. And with every
                  talk, a doubt was removed. A heart found peace. A mind found direction.
                </p>

                <p>
                  As the message grew, so did the trust.
                </p>

                <p>
                  Moved by his sincerity and commitment, people began donating—not to an
                  organization, but to a cause they believed in. That cause became the Islamic
                  Research Centre (IRC), a charitable trust born from the desire to bring knowledge
                  and welfare together in service of humanity.
                </p>

                <p>
                  From there, IRC's journey became one of impact educating minds, healing
                  bodies, and uplifting lives. Whether it's helping a child go to school, providing
                  water and healthcare to the underserved, or building professional skills for
                  employability, IRC's welfare programs are not an addition they are the living
                  expression of everything we teach.
                </p>

                <p>
                  Today, IRC stands as a beacon of guidance in a world clouded by confusion. We
                  work tirelessly to preserve and present the truth—converting hours of deep
                  research into accessible videos, simplifying complex texts, and now transforming
                  that knowledge into books, translations, and English resources for global reach.
                </p>

                <p>
                  We fight misinformation not with noise, but with evidence. We restore confidence
                  not with slogans, but with scholarship.
                </p>

                <p>
                  But behind every lesson taught, every life changed, and every project launched
                  there is one truth that keeps us grounded:
                </p>

                <p>
                  We did not do this alone.
                </p>

                <p>
                  We are here because of you our donors, volunteers, and well-wishers who believed
                  that trusted knowledge and compassionate service can still change the world. Your
                  support is not just financial; it's sacred trust. One we promise to honor with
                  integrity, accountability, and purpose.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Compliance Section */}
        <section className="compliance-section">
          <div className="section-container">
            <div className="mission-content">
              <h2>Legal & Compliance Status</h2>
              <div className='justified-text'>
                <p>
                  <strong>
                    Trust is earned—and we protect it with integrity.
                  </strong>
                </p>

                <p>
                  At Islamic Research Centre (IRC), we are deeply committed to ethical operations,
                  legal compliance, and transparent governance. Every rupee entrusted to us is
                  treated with accountability and care, and our processes reflect the trust our donors
                  and supporters place in us.
                </p>

                <li>✅ Registered NGO under the Indian Trusts Act Recognized as a legitimate
                  charitable trust, operating under legal frameworks in India.</li>
              </div>

              {/* Cards Grid */}
              <div className="compliance-cards-grid">
                {/* 12A Certified */}
                <div className="compliance-card">
                  <h3>12A Certified</h3>
                  <p>12A Certified IRC is officially recognized...</p>
                  <a
                    href={certificate12A}
                    download="12A_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>
                </div>

                {/* 80G Certified */}
                <div className="compliance-card">
                  <h3>80G Certified</h3>
                  <p>80G Certified Donations made...</p>
                  <a
                    href={certificate80G}
                    download="80G_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>
                </div>

                {/* ISO */}
                <div className="compliance-card">
                  <h3>ISO 9001:2015</h3>
                  <p>ISO 9001:2015 Certified...</p>
                  <a
                    href={certificateISO}
                    download="ISO_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>
                </div>

                {/* CSR */}
                <div className="compliance-card">
                  <h3>CSR Eligible Approved</h3>
                  <p>CSR Eligible Approved...</p>
                  <a
                    href={certificateCSR}
                    download="CSR_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>
                </div>

                <div className="compliance-card">
                  <h3>Charity Certificate</h3>
                  <p>Charity Certificate...</p>
                  <a
                    href={CharityCertificate}
                    download="CharityCertificate.jpg"
                    className="download-certificate-btnn"
                  >
                    📄 Download JPG
                  </a>
                </div>

                <div className="compliance-card">
                  <h3>Darpan Certificate</h3>
                  <p>Darpan Certificate...</p>
                  <a
                    href={DarpanCertificate}
                    download="DarpanCertificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>
                </div>
              </div>
              <div className='justified-text'>
                <p>
                  <strong>
                    These credentials ensure that IRC operates with the highest standards of ethics,
                    professionalism, and transparency. They also make it easier for individuals,
                    institutions, and corporate partners to support us with confidence.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;



























// import React, { useState } from 'react';
// import { pdfjs } from "react-pdf";
// import './About.css';
// import CarouselAbout from '../components/CarouselAbout';
// import OUR_MISSION from '../images/OUR_MISSION.webp';
// import our_vision from '../images/our_vision.webp';
// import Gratitude from '../images/Gratitude.webp';
// // import story from '../images/story.webp';
// // import legal from '../images/legal.webp';
// import certificate12A from '../images/12A_Certificate.pdf';
// import certificate80G from '../images/80G_Certificate.pdf';
// import certificateISO from '../images/ISO_Certificate.pdf';
// import certificateCSR from '../images/CSR_Certificate.pdf';
// import CharityCertificate from '../images/CharityCertificate.jpg';
// import DarpanCertificate from '../images/DarpanCertificate.pdf';


// pdfjs.GlobalWorkerOptions.workerSrc = 
//   `https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.js`;

// const About = () => {
//   const [loadedImages, setLoadedImages] = useState(new Set());

//   const handleImageLoad = (imageName) => {
//     setLoadedImages(prev => new Set(prev).add(imageName));
//   };

//   const isImageLoaded = (imageName) => {
//     return loadedImages.has(imageName);
//   };

//   const convertPdfToJpg = async (pdfFile, name) => {
//     const loadingTask = pdfjs.getDocument(pdfFile);
//     const pdf = await loadingTask.promise;
//     const page = await pdf.getPage(1); // first page only

//     const viewport = page.getViewport({ scale: 2 });
//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");

//     canvas.width = viewport.width;
//     canvas.height = viewport.height;

//     await page.render({ canvasContext: context, viewport }).promise;

//     // Convert canvas to JPG
//     const jpgData = canvas.toDataURL("image/jpeg");

//     // Trigger download
//     const link = document.createElement("a");
//     link.href = jpgData;
//     link.download = `${name}.jpg`; // dynamic file name
//     link.click();
//   };

//   return (
//     <>
//       <CarouselAbout />
//       <div className="about-us-container">
//         {/* Mission Section */}
//         <section className="mission-section">
//           <div className="section-container">
//             <div className="mission-content">
//               <h2>Our Mission</h2>
//               <div className='justified-text'>
//                 <p>
//                   1.	To go beyond imparting knowledge by transforming lives through compassionate actions by not only educating minds but also addressing the deeper needs of individuals and communities through empathy, care, and purposeful service.
//                 </p>
//                 <p>
//                   2.	To serve through action by providing education to the underprivileged, access to healthcare, skill development for youth, empowerment for women, and dignified social support for those in need, as the living expression of our mission.
//                 </p>
//                 <p>
//                   3.	To expand presence on digital platforms and community outreach, IRC serves as a voice of clarity in a world clouded by confusion and misinformation thereby removing doubts, reviving faith, and restoring trust in the beauty of Islam.
//                 </p>
//                 <p>
//                   4.	To deliver authentic, well-referenced Islamic knowledge in a clear and simplified format thereby removing barriers of language, complexity, and misinformation, so that every seeker can access and implement true Islamic guidance.
//                 </p>
//               </div>
//             </div>
//             <div className="mission-image">
//               <div className="image-wrapper">
//                 {!isImageLoaded('OUR_MISSION') && (
//                   <div className="image-placeholder">
//                     <div className="loading-spinner"></div>
//                     <span>Loading...</span>
//                   </div>
//                 )}
//                 <img
//                   src={OUR_MISSION}
//                   alt="Our Mission"
//                   loading="lazy"
//                   className={isImageLoaded('OUR_MISSION') ? 'loaded' : 'loading'}
//                   onLoad={() => handleImageLoad('OUR_MISSION')}
//                   onError={(e) => {
//                     e.target.style.display = 'none';
//                     handleImageLoad('OUR_MISSION');
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Vision Section */}
//         <section className="history-section">
//           <div className="section-container">
//             <div className="history-image">
//               <div className="image-wrapper">
//                 {!isImageLoaded('our_vision') && (
//                   <div className="image-placeholder">
//                     <div className="loading-spinner"></div>
//                     <span>Loading...</span>
//                   </div>
//                 )}
//                 <img
//                   src={our_vision}
//                   alt="Our Vision"
//                   loading="lazy"
//                   className={isImageLoaded('our_vision') ? 'loaded' : 'loading'}
//                   onLoad={() => handleImageLoad('our_vision')}
//                   onError={(e) => {
//                     e.target.style.display = 'none';
//                     handleImageLoad('our_vision');
//                   }}
//                 />
//               </div>
//             </div>
//             <div className="history-content">
//               <h2>Our Vision</h2>
//               <div className='justified-text'>
//                 <p>
//                   1.	To build a compassionate society where education and empathy go hand in hand uplifting hearts, minds, and lives.
//                 </p>
//                 <p>
//                   2.	To become a trusted global platform that dispels misinformation and revives the beauty of Islam through digital innovation and meaningful community engagement.
//                 </p>
//                 <p>
//                   3.	To lead in developing a skilled, self-reliant workforce through our technical institutions—empowering individuals with practical abilities to shape their own futures.
//                 </p>
//                 <p>
//                   4.	To create a future where authentic Islamic knowledge is accessible to every seeker, empowering individuals to live with clarity, faith, and purpose.
//                 </p>
//                 <p>
//                   <strong>
//                     None of this would be possible without the solid trust and generous support of our
//                     donors. Their contributions empower IRC to serve with fairness, integrity, and
//                     impact—fulfilling our mission
//                   </strong>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Gratitude Section */}
//         <section className="history-section">
//           <div className="section-container">
//             <div className="history-content">
//               <h2>Gratitude &amp; Trust: The Backbone of Our Welfare Work</h2>
//               <div className='justified-text'>
//                 <p>
//                   The reach and impact of IRC's social welfare efforts are made possible by the generous
//                   donations of individuals who believe in our mission and trust our integrity.
//                 </p>
//                 <p>
//                   IRC is committed to ensuring every donated rupee reaches the rightful beneficiaries, whether
//                   in the form of quality healthcare, skill training, educational assistance, or essential relief.
//                   We are driven by a sense of amanah (trust), knowing that every contribution carries with it
//                   the hope of positive change.
//                 </p>
//                 <p>
//                   We remain deeply grateful to our supporters, and continue to uphold their trust by maintaining
//                   transparency, impact-driven implementation, and a strong moral commitment to the communities
//                   we serve.
//                 </p>
//               </div>
//             </div>
//             <div className="history-image">
//               <div className="image-wrapper">
//                 {!isImageLoaded('Gratitude') && (
//                   <div className="image-placeholder">
//                     <div className="loading-spinner"></div>
//                     <span>Loading...</span>
//                   </div>
//                 )}
//                 <img
//                   src={Gratitude}
//                   alt="Gratitude and Trust"
//                   loading="lazy"
//                   className={isImageLoaded('Gratitude') ? 'loaded' : 'loading'}
//                   onLoad={() => handleImageLoad('Gratitude')}
//                   onError={(e) => {
//                     e.target.style.display = 'none';
//                     handleImageLoad('Gratitude');
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Story Section */}
//         <section className="mission-section">
//           <div className="section-container">
//             <div className="mission-content">
//               <h2>Our Story</h2>
//               <div className='justified-text'>
//                 <p>
//                   What began as one man's search for truth has grown into a movement that touches
//                   millions.
//                 </p>
//                 <p>
//                   More than 25 years ago, Adv. Faiz Syed set out on a path of deep study, navigating
//                   the vast oceans of complex Islamic texts, from the Qur'an to classical Hadith
//                   compilations and scholarly works. He realized that for the average seeker, access
//                   to authentic Islamic knowledge was blocked, not by lack of sincerity, but by
//                   language barriers, outdated beliefs, and a maze of misinformation. So, he
//                   dedicated his life to simplifying, referencing, and sharing that knowledge
//                   honestly, clearly, and fearlessly.
//                 </p>
//                 <p>
//                   People began to listen. First in person, then on YouTube, in conferences, on
//                   television panels. They came not just for answers, but for clarity. And with every
//                   talk, a doubt was removed. A heart found peace. A mind found direction.
//                 </p>

//                 <p>
//                   As the message grew, so did the trust.
//                 </p>

//                 <p>
//                   Moved by his sincerity and commitment, people began donating—not to an
//                   organization, but to a cause they believed in. That cause became the Islamic
//                   Research Centre (IRC), a charitable trust born from the desire to bring knowledge
//                   and welfare together in service of humanity.
//                 </p>

//                 <p>
//                   From there, IRC's journey became one of impact educating minds, healing
//                   bodies, and uplifting lives. Whether it's helping a child go to school, providing
//                   water and healthcare to the underserved, or building professional skills for
//                   employability, IRC's welfare programs are not an addition they are the living
//                   expression of everything we teach.
//                 </p>

//                 <p>
//                   Today, IRC stands as a beacon of guidance in a world clouded by confusion. We
//                   work tirelessly to preserve and present the truth—converting hours of deep
//                   research into accessible videos, simplifying complex texts, and now transforming
//                   that knowledge into books, translations, and English resources for global reach.
//                 </p>

//                 <p>
//                   We fight misinformation not with noise, but with evidence. We restore confidence
//                   not with slogans, but with scholarship.
//                 </p>

//                 <p>
//                   But behind every lesson taught, every life changed, and every project launched
//                   there is one truth that keeps us grounded:
//                 </p>

//                 <p>
//                   We did not do this alone.
//                 </p>

//                 <p>
//                   We are here because of you our donors, volunteers, and well-wishers who believed
//                   that trusted knowledge and compassionate service can still change the world. Your
//                   support is not just financial; it's sacred trust. One we promise to honor with
//                   integrity, accountability, and purpose.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Compliance Section */}
//         <section className="compliance-section">
//           <div className="section-container">
//             <div className="mission-content">
//               <h2>Legal & Compliance Status</h2>
//               <div className='justified-text'>
//                 <p>
//                   <strong>
//                     Trust is earned—and we protect it with integrity.
//                   </strong>
//                 </p>

//                 <p>
//                   At Islamic Research Centre (IRC), we are deeply committed to ethical operations,
//                   legal compliance, and transparent governance. Every rupee entrusted to us is
//                   treated with accountability and care, and our processes reflect the trust our donors
//                   and supporters place in us.
//                 </p>

//                 <li>✅ Registered NGO under the Indian Trusts Act Recognized as a legitimate
//                   charitable trust, operating under legal frameworks in India.</li>
//               </div>

//               {/* Cards Grid */}
//               <div className="compliance-cards-grid">
//                 {/* 12A Certified */}
//                 <div className="compliance-card">
//                   <h3>12A Certified</h3>
//                   <p>12A Certified IRC is officially recognized...</p>
//                   <a
//                     href={certificate12A}
//                     download="12A_Certificate.pdf"
//                     className="download-certificate-btnn"
//                   >
//                     📄 Download PDF
//                   </a>

//                   <button
//                     onClick={() => convertPdfToJpg(certificate12A, "12A_Certificate")}
//                     className="download-certificate-btn"
//                   >
//                     🖼️ Download JPG
//                   </button>
//                 </div>

//                 {/* 80G Certified */}
//                 <div className="compliance-card">
//                   <h3>80G Certified</h3>
//                   <p>80G Certified Donations made...</p>
//                   <a
//                     href={certificate80G}
//                     download="80G_Certificate.pdf"
//                     className="download-certificate-btnn"
//                   >
//                     📄 Download PDF
//                   </a>

//                   <button
//                     onClick={() => convertPdfToJpg(certificate80G, "80G_Certificate")}
//                     className="download-certificate-btn"
//                   >
//                     🖼️ Download JPG
//                   </button>
//                 </div>

//                 {/* ISO */}
//                 <div className="compliance-card">
//                   <h3>ISO 9001:2015</h3>
//                   <p>ISO 9001:2015 Certified...</p>
//                   <a
//                     href={certificateISO}
//                     download="ISO_Certificate.pdf"
//                     className="download-certificate-btnn"
//                   >
//                     📄 Download PDF
//                   </a>

//                   <button
//                     onClick={() => convertPdfToJpg(certificateISO, "ISO_Certificate")}
//                     className="download-certificate-btn"
//                   >
//                     🖼️ Download JPG
//                   </button>
//                 </div>

//                 {/* CSR */}
//                 <div className="compliance-card">
//                   <h3>CSR Eligible Approved</h3>
//                   <p>CSR Eligible Approved...</p>
//                   <a
//                     href={certificateCSR}
//                     download="CSR_Certificate.pdf"
//                     className="download-certificate-btnn"
//                   >
//                     📄 Download PDF
//                   </a>

//                   <button
//                     onClick={() => convertPdfToJpg(certificateCSR, "CSR_Certificate")}
//                     className="download-certificate-btn"
//                   >
//                     🖼️ Download JPG
//                   </button>
//                 </div>

//                 <div className="compliance-card">
//                   <h3>Charity Certificate</h3>
//                   <p>Charity Certificate...</p>
//                   <a
//                     href={CharityCertificate}
//                     download="CharityCertificate.jpg"
//                     className="download-certificate-btnn"
//                   >
//                     📄 Download JPG
//                   </a>
//                 </div>

//                 <div className="compliance-card">
//                   <h3>Darpan Certificate</h3>
//                   <p>Darpan Certificate...</p>
//                   <a
//                     href={DarpanCertificate}
//                     download="DarpanCertificate.pdf"
//                     className="download-certificate-btnn"
//                   >
//                     📄 Download PDF
//                   </a>

//                   <button
//                     onClick={() => convertPdfToJpg(DarpanCertificate, "DarpanCertificate")}
//                     className="download-certificate-btn"
//                   >
//                     🖼️ Download JPG
//                   </button>
//                 </div>
//               </div>
//               <div className='justified-text'>
//                 <p>
//                   <strong>
//                     These credentials ensure that IRC operates with the highest standards of ethics,
//                     professionalism, and transparency. They also make it easier for individuals,
//                     institutions, and corporate partners to support us with confidence.
//                   </strong>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default About;
